import axios from './index'

/**
 *
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param {Object} config [请求时其他配置]
 */
function get(url: string, params = {}, config = {}) {
    return new Promise((resolve, reject) => {
        axios
            .get(url, { params, ...config })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 *
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param {Object} config [请求时其他配置]
 */
function post(url: string, params = {}, config = {}) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, params, config)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export default { get, post }
